var APP = window.APP || [];

// Function for the next and prev calendar months
APP.initCalendarWidget = function() {

	var busy = false;

	// body.on click so the click is delegated every time,
	// even when .calendar is replaced with an ajax call
	$('body').on('click', '.calendar__header a', function(e) {

		// stop the click from taking you through to actual widget page
		e.preventDefault();

		// only allow one ajax fetch at a time
		if (busy) return;

		// we are busy!
		busy = true;

		//add a class of loading to the calendar to add fade css while loading the next calendar
		$('.calendar').addClass('loading');

		// set a variable of what the url should be to feed the ajax
		var href = $(this).attr('href');

		//AJAX call
		$.ajax({

			//url is our varaible set to the href attribute
			url : href,

			//once complete (either success or failure), remove the loading class
			// and re-allow click delegation
			complete : function(){
				$('.calendar').removeClass('loading');

				// ok done now
				busy = false;
			},

			// on success replace the calendar content with the ajax response content
			// and rebind tooltips
			success : function(response) {
				$('.calendar').replaceWith(response);
				}
		});
	});
};



/**
 * Handle video links by popping them into a fancybox
 */
APP.initFancyboxVideos = function() {
	// var $fancyboxMe = $('a[href*="vimeo.com"],a[href*="youtube.com"],a[href*="youtu.be"]');
	var $fancyboxMe = $('[data-fancybox*="vimeo.com"],[data-fancybox*="youtube.com"],[data-fancybox*="youtu.be"]');

	$.each($fancyboxMe, function(i) {
		$(this).fancybox({
				padding: 0,
				helpers : {
					media: {
						youtube : {
							params : {
								autoplay : 1
							}
						}
					}
				},
				width       : 960,
				height      : 540,
				aspectRatio : true,
				scrolling   : 'no',
				href 		: $(this).data('fancybox')
			});

	});
};


APP.initForm = function() {

	var $container = $('#groupMemberContainer');
	var $templateHTML = $('#template-group-member-row').html();
	var $addMemberButton = $('.fieldset--action-addMember');
	var newId = 0;

	// Show `Add Member` button
	if ($('input[id="fields_formMembershipSelection_group"]').attr('checked')) {
		$addMemberButton.removeClass('hidden');
	}

	// Show/hide `Add member` button
	$('.form__radio').change(function(){
		var $groupMemberSelect = $('input[value="group"]:checked').val();

		if ($groupMemberSelect != undefined) {
			$addMemberButton.removeClass('hidden');
		} else {
			$addMemberButton.addClass('hidden');

			// Check if any fieldset already added
			if ($container.children().length > 0) {
				// Remove all fieldset
				$container.children().remove();
			}
		}
	});

	$('.btn--addMember').on('click', function() {
		// Added a unique ID for form submission
		var newMember = $templateHTML.replace(/__ID__/g, 'memberID' + newId++);

		// Add fieldset template to form
		$container.append(newMember);
	});

	// Remove associated member fieldset
	$container.on('click', '.btn--removeMember', function() {
		$(this).closest('fieldset').remove();
	});
};

$(document).ready(function(){

	// bind carousels
	var $carousels = $('.owl-carousel');
	$.each($carousels, function() {
		var $carousel = $(this);

		$carousel.owlCarousel({
			items : 1,
			loop : true,
			lazyLoad : true,
			animateOut : 'fadeOut',
			mouseDrag : false,
			rtl : window.APP.dir == 'rtl',
			nav : true
		});

		// trigger next if click on .owl-item img (not the slide itself, because we may have a play button in there)
		$carousel.on('click', '.owl-item img', function(e, i) {
			$carousel.trigger('next.owl.carousel');
		});

		// as soon as the carousel first moves, lazyload everything
		$carousel.one('change.owl.carousel', function(e) {
			console.log('change.owl.carousel: lazyload entire owl carousel');
			$.each($carousel.find('.owl-lazy'), function() {
				var $self = $(this);

				$self.attr('src', $self.data('src')).removeClass('owl-lazy');
			});
		});
	});

	// bind mobile nav
	$('.nav--mobile__toggle').on('click', function(e) {
		e.preventDefault();
		$($(this).attr('href')).toggle();
	});

	// bind masonry
	var $container = $('.masonry__inner');
	// initialize Masonry after all images have loaded
	$container.imagesLoaded( function() {
		$container.masonry({
			containerStyle : null,
			gutter : 0,
			isOriginLeft : window.APP.dir == 'ltr'
		});
	});

	// bind filter toggle dropdowns
	$('.toggle').each(function(e) {
		var self = $(this),
			handle = self.find('.toggle__handle'),
			nav = self.find('.toggle__nav').first();

		handle.on('click', function (event) {

			event.preventDefault();

			self.toggleClass('toggle--open');

			nav.slideToggle('300', 'swing');
		});
	});

	/**
	  * Need to contain our Exhibition title text in parent.
	 	Tried but didn't quite work:
	 	- https://github.com/freqDec/slabText/
	 	- https://github.com/davatron5000/FitText.js

	 	So opted for a rough and simple approach for time being.
	 	It does NOT re-fire on resize.
		Borrowed from http://www.metaltoad.com/blog/resizing-text-fit-container
	  */
	function fitContainer(elem) {
		var fontstep = 1;
		if ($(elem).width()>$(elem).parent().width()) {
			$(elem).css('font-size',(($(elem).css('font-size').substr(0,2)-fontstep)) + 'px');
			fitContainer(elem);
		}
	}

	//changing the main shop product image when thumbnail is clicked
	$('.shopEntry__thumbImage').on('click', function(){
		var newImage = $(this).data('product');
		$('.shopEntry__productImage').attr('src', newImage );
	});

    fitContainer('.fitContainer');

	APP.initFancyboxVideos();

	$('.rte').fitVids();

	APP.initCalendarWidget();


	APP.initForm();
});
